export const environment = {
  apiUrl: 'https://api.prompt-validator.stable.quik-ai.corvus-it.com',
};
